exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_menuItem_moL5cOwnYsG9bz8ItmMWL {\n  width: 100%;\n  height: 45px;\n  position: relative;\n  float: left;\n  box-sizing: border-box;\n  clear: both;\n  padding-left: 10px;\n  box-sizing: border-box;\n  user-select: none;\n}\n\n.IA_title_2HVJxVSmG6-v-x37vsBWhA {\n  font-size: 13px;\n  float: left;\n  line-height: 45px;\n  width: calc(100% - 52px);\n  margin-left: 2px;\n  user-select: none;\n}", ""]);

// Exports
exports.locals = {
	"IA_menuItem": "IA_menuItem_moL5cOwnYsG9bz8ItmMWL",
	"IA_title": "IA_title_2HVJxVSmG6-v-x37vsBWhA"
};